import React from "react";
type FormMetadataProps = {
  title: string;
};
function FormMetadata({
  title
}: FormMetadataProps) {
  return <div className="pb-3" data-sentry-component="FormMetadata" data-sentry-source-file="FormMetadata.tsx">
      <h1 className="text-2xl text-foreground print:text-center">{title}</h1>
    </div>;
}
export default FormMetadata;